import {
  SegmentAbstraction,
  useAnalyticsPageView,
  useSegmentAnalytics,
} from '@nerdwallet/seo-analytics';
import analytics from '@nerdwallet/analytics';
import { useSegmentImpressionContext } from './segment-impression';
import { SegmentFieldEventPayloadT } from './types';

const useAnalytics = <T>(): {
  track: (
    eventType: string,
    eventPayload: SegmentFieldEventPayloadT<T>
  ) => Promise<void>;
} => {
  const parentEventId = useSegmentImpressionContext()?.eventId;
  const pageViewId = useAnalyticsPageView()?.pageViewId;
  const segment = useSegmentAnalytics()?.analytics;

  const track = async (
    eventType: string,
    eventPayload: SegmentFieldEventPayloadT<T>
  ) => {
    if (eventType === 'form_field_interacted' && !parentEventId) {
      return;
    }
    segment?.track(eventType, {
      parent_event_id: parentEventId,
      pageview_id: pageViewId,
      event_id: analytics.uuid(),
      ...eventPayload,
    });
  };

  return { track } as SegmentAbstraction;
};

export default useAnalytics;
